const SVGComponent = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="#0079BE"
    />
    <g clipPath="url(#clip0_2042_81685)">
      <path
        d="M17.0301 2.99838H14.9699C13.1214 2.99838 11.3486 3.73588 10.0414 5.04863C8.73433 6.36139 8 8.14187 8 9.99838C8 11.8549 8.73433 13.6354 10.0414 14.9481C11.3486 16.2609 13.1214 16.9984 14.9699 16.9984H17.0301C18.8786 16.9984 20.6514 16.2609 21.9585 14.9481C23.2657 13.6354 24 11.8549 24 9.99838C24 8.14187 23.2657 6.36139 21.9585 5.04863C20.6514 3.73588 18.8786 2.99838 17.0301 2.99838ZM14.9699 16.3266C13.7233 16.3266 12.5046 15.9553 11.468 15.2597C10.4315 14.5641 9.62355 13.5754 9.14647 12.4187C8.66939 11.262 8.54457 9.98912 8.78778 8.76113C9.03099 7.53315 9.63132 6.40516 10.5129 5.51983C11.3944 4.6345 12.5175 4.03159 13.7402 3.78732C14.9629 3.54306 16.2303 3.66843 17.3821 4.14756C18.5339 4.6267 19.5183 5.43809 20.2109 6.47913C20.9035 7.52017 21.2732 8.7441 21.2732 9.99614C21.273 11.675 20.6088 13.285 19.4268 14.4722C18.2447 15.6593 16.6416 16.3264 14.9699 16.3266Z"
        fill="white"
      />
      <path
        d="M13.5157 6.29852C12.7762 6.59138 12.1415 7.10092 11.6943 7.76091C11.247 8.42089 11.0078 9.20076 11.0078 9.99911C11.0078 10.7975 11.247 11.5773 11.6943 12.2373C12.1415 12.8973 12.7762 13.4069 13.5157 13.6997V6.29852Z"
        fill="white"
      />
      <path
        d="M16.4248 6.29852V13.6997C17.1643 13.4069 17.799 12.8973 18.2462 12.2373C18.6935 11.5773 18.9327 10.7975 18.9327 9.99911C18.9327 9.20076 18.6935 8.42089 18.2462 7.76091C17.799 7.10092 17.1643 6.59138 16.4248 6.29852Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2042_81685">
        <rect width={16} height={14} fill="white" transform="translate(8 3)" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;